import { render, staticRenderFns } from "./OurCar.vue?vue&type=template&id=1453aee1&scoped=true"
import script from "./OurCar.vue?vue&type=script&lang=js"
export * from "./OurCar.vue?vue&type=script&lang=js"
import style0 from "./OurCar.vue?vue&type=style&index=0&id=1453aee1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1453aee1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VContainer,VImg})
